<form class="form-vertical"
      [formGroup]="parkingForm">
  <div class="form-row row">
    <div class="form-group">
      <label for="name"
             class="control-label">{{'i18n.shared.fields.name' | translate}}</label>
      <input type="text"
             id="name"
             class="form-control e-textbox"
             formControlName="name"
             name="name">
      <app-error-messages [control]="parkingForm.controls.name"></app-error-messages>
    </div>
  </div>

  <div class="form-row row">
    <div class="form-group">
      <label for="clientId">{{ 'i18n.domain.parking.client' | translate }}</label>
      <ejs-dropdownlist [fields]="clientDropdownSettings"
                        formControlName="clientId"
                        id="clientId"
                        (change)="resetZone($event)"
                        [dataSource]="clientDropdownValues"></ejs-dropdownlist>
    </div>
  </div>

  <div class="form-row row"
       *ngIf="clientSelected">
    <div class="form-group">
      <label for="zoneId">{{ 'i18n.domain.parking.zone' | translate }}</label>
      <ejs-dropdownlist [fields]="clientDropdownSettings"
                        formControlName="zoneId"
                        id="zoneId"
                        (change)="resetSubscription($event)"
                        [dataSource]="zoneDropdownValues">
        <ng-template #valueTemplate
                     let-data>
          <div class="line-height"
               *ngIf="data?.name.length">
                <span *ngFor="let zone of data.name; let last=last"
                      [ngClass]="{'fw-bold': last}"
                      class="slash-separated">{{zone}}</span>
          </div>
        </ng-template>
        <ng-template #itemTemplate
                     let-data>
          <ng-container *ngIf="data?.name.length">
                <span *ngFor="let zone of data.name; let last=last"
                      [ngClass]="{'fw-bold': last}"
                      class="slash-separated">{{zone}}</span>
          </ng-container>
        </ng-template>
      </ejs-dropdownlist>
    </div>
  </div>

  <div class="form-row row"
       *ngIf="zoneSelected">
    <div class="form-group">
      <label for="subscriptionId">{{ 'i18n.domain.parking.subscription' | translate }}</label>
      <ejs-dropdownlist [fields]="clientDropdownSettings"
                        formControlName="subscriptionId"
                        id="subscriptionId"
                        (change)="resetWeekdays($event)"
                        [dataSource]="subscriptionsDropdownValues"></ejs-dropdownlist>
    </div>
  </div>

  <div class="form-row row"
       *ngIf="zoneSelected && parkingSpaceNumberDefinition != null">
    <div class="form-group">
      <label for="parkingSpaceNumber">{{ 'i18n.domain.parking.parkingSpaceNumber' | translate }}</label>
      <input type="text" class="form-control"
                        formControlName="parkingSpaceNumber"
                        id="parkingSpaceNumber"/>
    </div>
  </div>

  <div class="form-row row" *ngIf="clientSelected">
    <div class="form-group">
      <label for="controlPlateId">{{ 'i18n.domain.parking.storedVehicle' | translate }}</label>
      <ejs-dropdownlist [fields]="clientDropdownSettings"
                        formControlName="controlPlateId"
                        id="controlPlateId"
                        [dataSource]="controlPlateDropdownValues"></ejs-dropdownlist>
    </div>
  </div>

  <div class="form-row row mt-2" *ngIf="isSubscriptionSelected">
    <div class="form-group">
      <label>{{ 'i18n.domain.parking-administration.edit.validAt' | translate }}</label>
      <app-day-selector [form]="weekdaysFormGroup"></app-day-selector>
    </div>
  </div>

  <div class="form-row row mt-2" *ngIf="parkingForm.controls.weekdays.valid">
    <div class="form-group">
      <div *ngIf="hasPossibleStartTimeRanges; else noMatchingSlices">
        <app-time-picker-with-time-slider
                                        [form]="timePickerFormGroup"
                                        [maxDuration]="maxDuration"
                                        [timepickerStrictMode]="true"
                                        [showSliderBeforeTimeSelection]="false"
                                        [possibleStartTimeRanges]="possibleStartTimeRanges"
                                        (startTimeChange)="onStartTimeChange($event)"></app-time-picker-with-time-slider>

        <div *ngIf="!parkingForm.controls.startTime.valid">
          <div>{{'i18n.domain.parking-administration.possible-time-ranges' | translate}}:</div>
          <div>
            <table class="form-text-size">
              <tr *ngFor="let range of possibleStartTimeRanges">
                <td>{{range.startTimeStr}}</td>
                <td class="window-delimiter">-</td>
                <td>{{range.endTimeStr}}</td>
                <td>{{range.possibleParkingEndTime}}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <ng-template #noMatchingSlices>
        {{'i18n.domain.parking-administration.no-overlapping-tariffs' | translate}}
      </ng-template>
    </div>
  </div>

  <div class="form-row row"
       *ngIf="isEdit">
    <div class="form-group col-md-12">
      <label for="isActive"
             class="d-block">{{'i18n.shared.fields.active' | translate}}</label>
      <app-yes-no-group-button id="isActive"
                               formControlName="isActive"></app-yes-no-group-button>
    </div>
  </div>

  <div class="row" *ngIf="overlappingSchedule">
    <div class="col-12">
      <div class="alert alert-danger overlapping-schedule-alert">
        {{'i18n.domain.parking-administration.overlapping-schedule-error' | translate: {name: overlappingSchedule.name} }}
      </div>
    </div>
  </div>
</form>
